import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { useProps } from "./auth-service-tools225.js";
import { factory } from "./auth-service-tools248.js";
import { Input } from "./auth-service-tools299.js";
import { InputsGroupFieldset } from "./auth-service-tools322.js";
import { RadioGroupProvider } from "./auth-service-tools394.js";
import { useId } from "./auth-service-tools271.js";
import { useUncontrolled } from "./auth-service-tools323.js";
const defaultProps = {};
const RadioGroup = factory((props, ref) => {
  const {
    value,
    defaultValue,
    onChange,
    size,
    wrapperProps,
    children,
    name,
    readOnly,
    ...others
  } = useProps("RadioGroup", defaultProps, props);

  const _name = useId(name);

  const [_value, setValue] = useUncontrolled({
    value,
    defaultValue,
    finalValue: "",
    onChange
  });

  const handleChange = event => !readOnly && setValue(typeof event === "string" ? event : event.currentTarget.value);

  return /* @__PURE__ */jsxRuntimeExports.jsx(RadioGroupProvider, {
    value: {
      value: _value,
      onChange: handleChange,
      size,
      name: _name
    },
    children: /* @__PURE__ */jsxRuntimeExports.jsx(Input.Wrapper, {
      size,
      ref,
      ...wrapperProps,
      ...others,
      labelElement: "div",
      __staticSelector: "RadioGroup",
      children: /* @__PURE__ */jsxRuntimeExports.jsx(InputsGroupFieldset, {
        role: "radiogroup",
        children
      })
    })
  });
});
RadioGroup.classes = Input.Wrapper.classes;
RadioGroup.displayName = "@mantine/core/RadioGroup";
export { RadioGroup };